import { createContext, useContext, type Context } from 'react';

/** Navigation configuration is local to the provider, never part of shared credit snapshots. */
export const CreditsUsageContext: Context<string | undefined> = createContext<string | undefined>(
	undefined,
);
export const useCreditsUsageUrl = (): string | undefined => useContext(CreditsUsageContext);
